import { render, staticRenderFns } from "./CandidatesLabel.vue?vue&type=template&id=12e4a07e&scoped=true&lang=pug"
import script from "./CandidatesLabel.vue?vue&type=script&lang=js"
export * from "./CandidatesLabel.vue?vue&type=script&lang=js"
import style0 from "./CandidatesLabel.vue?vue&type=style&index=0&id=12e4a07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4a07e",
  null
  
)

export default component.exports